module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	fox.registerWidget('Social_Rating', {
		configure: function() {
			this.registerOptions('', {
				'handleDom.rate': {
					event: 'click',
					target: '.rate',
					callback: 'rateDomHandler'
				},
				template: 'social_rating',
				container: '.rating',
				'methods.load': 'social.rater.load',
				'methods.rate': 'social.rater.rate'
			});

			this.callParent('configure', arguments);
		},

		rateDomHandler: function(elt) {
			var targetId = parseInt(elt.getAttribute('data-target-id'));
			var value = parseInt(elt.getAttribute('data-value'));
			this.rate(targetId, value);
		},

		rate: function(targetId, value) {
			var info = this.prepareDataItem(this.data[targetId], targetId);

			value = Number(value);

			if (fox.isSet(info.currentMemberRating)) {
				if (info.currentMemberRating === value) {
					return;
				} else {
					info.rating = info.rating - info.currentMemberRating + value;
					info.currentMemberRating = value;
				}
			} else {
				info.rating = info.rating + value;
				info.voters++;
				info.currentMemberRating = value;
			}

			this.data[targetId] = this.prepareDataItem(info, targetId);
			this.render();

			var apiData = {
				targetId: targetId,
				value: value,
				isHidePreloader: true,
				subject: this.getOption('subject')
			};

			return this.getApi('rate').send(apiData, false);
		},

		prepareDataItem: function(item, targetId) {
			item.good = Math.floor(item.rating / 5) || 0;
			item.bad = Math.floor(item.voters - item.good) || 0;
			item.total = item.good - item.bad;
			return this.callParent('prepareDataItem', arguments);
		}

	}, 'Social_Activity');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/social/rating.js
// module id = 454
// module chunks = 4